import { useMutation } from '@apollo/client';
import clientAccount from 'apps/accounts/app/utils/clientAccount';
import useNotifier from 'hooks/useNotifier';
import { handleGQLErrors } from 'utils/gqlErrors';
import { updateAvatarByItemIDMutation } from '../mutations';
import { UpdateAvatarByItemID, UpdateAvatarByItemIDVariables } from '../types/UpdateAvatarByItemID';

const useUpdateAvatar = ({ onComplete }: { onComplete?: () => void }) => {
  const notify = useNotifier();
  const [mutation, mutationOpts] = useMutation<
    UpdateAvatarByItemID,
    UpdateAvatarByItemIDVariables
  >(updateAvatarByItemIDMutation, {
    client: clientAccount,
    onCompleted: (data) => {
      if (onComplete) {
        onComplete();
      } else {
        notify({ text: 'Updated successfully', status: 'success' });
      }
    },
    onError: (err) => {
      handleGQLErrors(notify, err);
    },
  });

  return {
    mutation,
    mutationOpts,
  };
};

export default useUpdateAvatar;
